import styled from 'styled-components';

const StyledCrawledVendorDetailsPage = styled.div`
    height: 100%;
    width: 100%;
    margin-top: 100px;
    @media (max-width: 815px) {
        margin-top: 50px;
    }

    .category-location-style {
        padding-left: 50px;
    }

    .button-style {
        border: 1px solid ${(props) => props.theme.colors.accent.base};
        background-color: ${(props) => props.theme.colors.accent.base};
        margin-top: 8px;
        color: ${(props) => props.theme.colors.accent.hover};
        &:hover {
            color: ${(props) => props.theme.colors.accent.base};
            background-color: ${(props) => props.theme.colors.accent.hover};
        }
    }
`;

export default StyledCrawledVendorDetailsPage;
